import { Card, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { Button } from '@/components/ui/Button';
import type { PlanConfig } from '@/types/admin.types';
import { formatCurrency } from '@/utils/formatters';
import { Edit2 } from 'lucide-react';

interface PlanEditorProps {
  plans: PlanConfig[];
  onEdit: (plan: PlanConfig) => void;
}

export function PlanEditor({ plans, onEdit }: PlanEditorProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
      {plans.map((plan) => (
        <Card key={plan.uuid}>
          <CardContent>
            <div className="flex items-center justify-between mb-3">
              <h3 className="font-semibold text-neutral-900 dark:text-neutral-200">{plan.name}</h3>
              <Badge variant={plan.isActive ? 'success' : 'neutral'}>
                {plan.isActive ? 'Actif' : 'Inactif'}
              </Badge>
            </div>
            <div className="space-y-2 text-sm text-neutral-600 dark:text-neutral-400">
              <div className="flex justify-between"><span>Prix/dossier</span><span className="text-neutral-900 dark:text-neutral-200">{formatCurrency(plan.pricePerFolder)}</span></div>
              <div className="flex justify-between"><span>Prix/coffre</span><span className="text-neutral-900 dark:text-neutral-200">{formatCurrency(plan.pricePerVault)}</span></div>
              <div className="flex justify-between"><span>Dossiers inclus</span><span className="text-neutral-900 dark:text-neutral-200">{plan.includedFolders}</span></div>
              <div className="flex justify-between"><span>Coffres inclus</span><span className="text-neutral-900 dark:text-neutral-200">{plan.includedVaults}</span></div>
            </div>
            {plan.features.length > 0 && (
              <div className="mt-3 flex flex-wrap gap-1">
                {plan.features.map((f) => (
                  <Badge key={f} variant="neutral" className="text-[10px]">{f}</Badge>
                ))}
              </div>
            )}
            <Button variant="outline" size="sm" className="mt-4 w-full" icon={<Edit2 className="h-3 w-3" />} onClick={() => onEdit(plan)}>
              Modifier
            </Button>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
